import React, { Component } from 'react'

class IconPhone extends Component {
  render() {
    return (
      <svg className="phones" width="70" height="64">
        <g fillRule="nonzero" fill="none">
          <path
            d="M28.232 5.253L2.437 14.707c-1.933.709-2.92 2.833-2.204 4.746l15.733 42.032c.716 1.913 2.863 2.889 4.796 2.18l25.796-9.453c1.933-.709 2.92-2.834 2.203-4.746L33.028 7.434c-.716-1.913-2.863-2.89-4.796-2.18z"
            fill="#485878"
          />
          <path
            d="M33.028 7.434a3.693 3.693 0 0 0-1.815-2.012L17.137 42.986a7.738 7.738 0 0 0 .229 6.016 7.864 7.864 0 0 0 4.46 4.094l13.88 5.092 10.852-3.976c1.932-.709 2.92-2.834 2.203-4.746L33.028 7.434z"
            fill="#333F61"
          />
          <path
            d="M27.343 9.647l-21.339 7.82a2.223 2.223 0 0 0-1.33 2.866l14.082 37.622a2.26 2.26 0 0 0 2.896 1.317l21.339-7.82a2.223 2.223 0 0 0 1.33-2.866L30.238 10.964a2.26 2.26 0 0 0-2.895-1.317z"
            fill="#EFEFEF"
          />
          <path
            d="M30.238 10.964a2.217 2.217 0 0 0-.732-.986l-12.37 33.008a7.738 7.738 0 0 0 .23 6.016 7.864 7.864 0 0 0 4.46 4.094l8.334 3.057 12.83-4.702a2.223 2.223 0 0 0 1.33-2.865L30.239 10.964z"
            fill="#D4D4D4"
          />
          <path
            d="M35.91 34.988l-9.05-8.12-1.862-5.116.532-.194a.453.453 0 0 0 .272-.581l-.314-.862a.453.453 0 0 0-.581-.27l-.533.193-5.473 1.992-.487.178a.453.453 0 0 0-.271.581l.313.861a.453.453 0 0 0 .581.271l.488-.177 1.863 5.117-1.302 11.837c-.544 2.445.923 3.733 3.277 2.876L35.3 39.23c2.354-.857 2.628-2.756.611-4.242zM23.191 29.06l.046-.42-.144-.398-1.863-5.118 2.063-.75 1.862 5.117.156.427.337.303 3.878 3.479-6.901 2.512.566-5.152z"
            fill="#485878"
            opacity=".341"
          />
          <path
            d="M67.428 9.695L41.636.23c-1.932-.709-4.08.267-4.797 2.18L21.091 44.436c-.717 1.912.269 4.037 2.202 4.746l25.792 9.463c1.932.71 4.08-.266 4.796-2.178L69.63 14.44c.716-1.912-.27-4.037-2.202-4.746z"
            fill="#3D4B65"
          />
          <path
            d="M63.86 12.454L42.524 4.626a2.26 2.26 0 0 0-2.896 1.315L25.532 43.558a2.223 2.223 0 0 0 1.329 2.866l21.336 7.828a2.26 2.26 0 0 0 2.896-1.315l14.096-37.618a2.222 2.222 0 0 0-1.33-2.865z"
            fill="#EFEFEF"
          />
          <path
            d="M45.1 20.045c-5.515 0-10 4.485-10 9.998 0 5.513 4.485 9.998 10 9.998 5.513 0 10-4.485 10-9.998 0-5.513-4.487-9.998-10-9.998zm.516 2.912l2.027-1.462a8.971 8.971 0 0 1 4.757 3.433l-.777 2.411-2.76.893-3.247-2.347v-2.928zm-3.082-1.462l2.004 1.462v2.928l-3.194 2.325-2.81-.914-.764-2.347a8.951 8.951 0 0 1 4.764-3.454zm-4.59 13.872a8.873 8.873 0 0 1-1.764-5.569l2.032-1.476 2.872.933 1.19 3.656-1.79 2.463-2.54-.007zm10.028 3.122a8.887 8.887 0 0 1-2.873.474 8.884 8.884 0 0 1-2.954-.503l-.795-2.444 1.797-2.472h3.805l1.817 2.5-.797 2.445zm1.677-3.067l-1.756-2.415 1.21-3.716 2.856-.928 2.06 1.5.003.18c0 2.02-.676 3.886-1.813 5.383l-2.56-.004z"
            fill="#485878"
            opacity=".341"
          />
        </g>
      </svg>
    )
  }
}

export default IconPhone



// WEBPACK FOOTER //
// ./src/svg/iconphone.js